import logo from './../../../app/images/logo.png';
import arrLeft from './../../../app/images/arr-left.png';
import { useNavigate } from 'react-router-dom';

import './style.scss';

interface Props {
  children: JSX.Element | JSX.Element[];
  title: string;
  backLogin?: boolean;
  className?: string;
}

const FormWrapper = (props: Props) => {
  const { title, children, backLogin, className } = props;

  const navigate = useNavigate();

  const handleBackLogin = () => {
    navigate('/auth/sign-in');
  };

  return (
    <>
      <img src={logo} alt="logo" className="logo-img" />

      <div className={`form-wrap ${className}`}>
        {backLogin && <img src={arrLeft} alt="back" className="back-login cursor-pointer" onClick={handleBackLogin} />}

        {backLogin && <div className="separator"></div>}

        {!!title && <h3 className={'title m-0 mb-3 text-center text-uppercase fw-semibold'}>{title}</h3>}

        {children}
      </div>
    </>
  );
};

export default FormWrapper;
